// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

import Scroller from '@newswire/scroller';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!

var scenes = document.querySelectorAll('.scene');
var img = document.querySelectorAll('.scroll-topper img');

const offset = 0;

const scroller = new Scroller({
  container: document.querySelector('.scroll-topper'),
  scenes: document.querySelectorAll('.scene'),
  offset: offset,
});

scroller.on('scene:enter', function (d) {
  var slideList = document.getElementsByClassName('slide');
  var slideIndex = d.index;

  img[slideIndex].classList.add('show');

  var down = d.isScrollingDown;
});

scroller.on('scene:exit', function (d) {
  var slideList = document.getElementsByClassName('slide');
  var slideIndex = d.index;
  var down = d.isScrollingDown;

  if (down == false) {
    img[slideIndex].classList.remove('show');
  }
});

scroller.on('init', () => {});

// starts up the IntersectionObserver
scroller.init();
